import initVodSettingsAdapter from 'transport/adapters/vod/settings';

import { vodAdapterSettings } from './config';

export const vodSettingsAdapter = initVodSettingsAdapter(vodAdapterSettings);



// WEBPACK FOOTER //
// ./src/shared/utils/adapters/vod-settings.js